import { clsx } from 'clsx';
import { StatusBadge } from '@treezor/design-system';

import { TStatusLabelProps } from '@/ui-kit/status-label/StatusLabel.types';

export function StatusLabel({ label, status, ...rest }: TStatusLabelProps) {
  const getBadgeColor = () => {
    switch (status) {
      case 'neutral':
        return 'gray';
      case 'success':
        return 'green';
      case 'error':
        return 'red';
      case 'pending':
        return 'orange';
      case 'info':
        return 'blue';
      default:
        return 'gray';
    }
  };

  return (
    <StatusBadge
      label={label}
      color={getBadgeColor()}
      emphasis="low"
      size="s"
      {...rest}
      className={clsx('w-fit', rest?.onClick && 'cursor-pointer')}
    />
  );
}
